import api from './apiClient';

export const postsAPI = {
  getPosts: async () => {
    const response = await api.get('/api/posts');
    return response.data;
  },
  getPostById: async (id) => {
    const response = await api.get(`/api/posts/${id}`);
    return response.data;
  },
  createPost: async (postData) => {
    const response = await api.post('/api/posts', postData);
    return response.data;
  },
  updatePost: async (id, postData) => {
    const response = await api.post(`/api/posts/${id}`, postData);
    return response.data;
  },
  deletePost: async (id) => {
    await api.post(`/api/posts/${id}/delete`, {});
  },
};
